"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsService = exports.UNIT_OPTIONS = exports.DEFAULT_UNIT = exports.DEFAULT_DATE = exports.DATE_OPTIONS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
var user_service_1 = require("./user.service");
exports.DATE_OPTIONS = [
    'MM/DD/YYYY',
    'DD/MM/YYYY'
];
exports.DEFAULT_DATE = exports.DATE_OPTIONS[0];
exports.DEFAULT_UNIT = core_shared_1.IkeUnit.FEET;
exports.UNIT_OPTIONS = [
    { unit: core_api_1.IkeUnitDistance.METER, label: i18n_1.T.UNIT_METER },
    { unit: core_api_1.IkeUnitDistance.FEET, label: i18n_1.T.UNIT_FEET_INCH }
];
var UserSettingsService = /** @class */ (function () {
    function UserSettingsService() {
        this.__priority = 100;
    }
    UserSettingsService.prototype.getSettings = function () {
        var currentUser = index_1.Services.User.current;
        if (currentUser == null) {
            throw new Error('Invalid user.');
        }
        if (currentUser.settings == null) {
            currentUser.settings = {};
        }
        return currentUser.settings;
    };
    UserSettingsService.prototype.setDateFormat = function (dateFormat) {
        dateFormat = dateFormat.toUpperCase();
        if (exports.DATE_OPTIONS.indexOf(dateFormat) === -1) {
            throw new Error('Invalid DateFormat.');
        }
        if (dateFormat === this.dateFormat) {
            return Promise.resolve(index_1.Services.User.current);
        }
        return user_service_1.UserMutator.setDateFormat(dateFormat);
    };
    UserSettingsService.prototype.setUnits = function (units) {
        var ikeUnits = core_shared_1.IkeUnit.toUnitDistance(units);
        if (ikeUnits == null) {
            throw new Error('Invalid Unit: ' + units);
        }
        if (ikeUnits === this.units) {
            return Promise.resolve(index_1.Services.User.current);
        }
        return user_service_1.UserMutator.setUnits(ikeUnits);
    };
    UserSettingsService.prototype.setDepartment = function (departmentId) {
        if (departmentId == null) {
            throw new Error('Invalid departmentId');
        }
        if (departmentId === this.departmentId) {
            return Promise.resolve(index_1.Services.User.current);
        }
        index_1.Services.Route.departmentReset();
        return user_service_1.UserMutator.setDepartment(departmentId);
    };
    Object.defineProperty(UserSettingsService.prototype, "units", {
        get: function () {
            if (index_1.Services.User.current == null) {
                return exports.DEFAULT_UNIT;
            }
            var settings = this.getSettings();
            if (settings.units == null) {
                return exports.DEFAULT_UNIT;
            }
            return settings.units || exports.DEFAULT_UNIT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSettingsService.prototype, "dateFormat", {
        get: function () {
            if (index_1.Services.User.current == null) {
                return exports.DEFAULT_DATE;
            }
            var settings = this.getSettings();
            if (settings.date == null) {
                return exports.DEFAULT_DATE;
            }
            return settings.date || exports.DEFAULT_DATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSettingsService.prototype, "departmentId", {
        get: function () {
            if (index_1.Services.User.current == null) {
                return null;
            }
            var settings = this.getSettings();
            if (settings.departmentId != null) {
                return settings.departmentId;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], UserSettingsService.prototype, "units", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserSettingsService.prototype, "dateFormat", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserSettingsService.prototype, "departmentId", null);
    return UserSettingsService;
}());
exports.UserSettingsService = UserSettingsService;
//# sourceMappingURL=user.settings.service.js.map